import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { FiltersBar } from '../../../components/ui/FiltersBar';
import { userData } from '../../../util/userData';
import { selectFilters, updateFilters } from '../filters/filtersSlice';
import { useAppDispatch, useAppSelector } from '../hooks';
import { AttributesTableComponent } from './AttributesTableComponent';
import {
  loadAttributesTable,
  selectAttributesTableState,
} from './AttributesTableComponent/attributesTableComponentSlice';
import { ComparisonComponent } from './ComparisonComponent';
import {
  loadComparison,
  selectIsComparisonDataLoading,
} from './ComparisonComponent/comparisonComponentSlice';
import { DistributionComponent } from './DistributionComponent';
import {
  loadDistribution,
  selectIsDistributionDataLoading,
} from './DistributionComponent/distributionComponentSlice';
import { TrendComponent } from './TrendComponent';
import {
  loadTrendData,
  selectIsTrendDataLoading,
} from './TrendComponent/trendComponentSlice';

export const Dashboard = () => {
  const filters = useAppSelector(selectFilters);
  const attributesTableComponentState = useAppSelector(
    selectAttributesTableState
  );
  const isAttributesTableLoading = attributesTableComponentState.isLoading;
  const isTrendLoading = useAppSelector(selectIsTrendDataLoading);
  const isDistributionLoading = useAppSelector(selectIsDistributionDataLoading);
  const isComparisonLoading = useAppSelector(selectIsComparisonDataLoading);
  const [isDashboardLoading, setIsDashboardLoading] = useState(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    userData.filtersListen((updatedFilters) => {
      dispatch(updateFilters(updatedFilters));
    });
  }, []);

  useEffect(() => {
    if (!filters.period || !filters.survey || !filters.hier) {
      return;
    }

    dispatch(loadAttributesTable(filters));
    dispatch(loadTrendData(filters));
    dispatch(loadDistribution(filters));
    dispatch(loadComparison(filters));
  }, [filters]);

  useEffect(() => {
    if (
      !isAttributesTableLoading &&
      !isTrendLoading &&
      !isDistributionLoading &&
      !isComparisonLoading
    ) {
      setIsDashboardLoading(false);
    } else {
      setIsDashboardLoading(true);
    }
  }, [
    isAttributesTableLoading,
    isTrendLoading,
    isDistributionLoading,
    isComparisonLoading,
  ]);

  return (
    <main>
      <FiltersBar
        hideQuestions
        hideMetrics
        hideCommentTypes
        showAllCoachingFormOption
        showMonthPicker
        useNewContainer
        dateRangeDataFetchStatus={isDashboardLoading}
      />
      <div className="blacklight">
        <Container fluid={true}>
          <Row>
            <Col sm={12} md={5}>
              <AttributesTableComponent />
            </Col>
            <Col sm={12} md={7}>
              <Row>
                <Col sm={12} md={6}>
                  <TrendComponent />
                  <DistributionComponent />
                </Col>
                <Col sm={12} md={6}>
                  <ComparisonComponent />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </main>
  );
};
